module.exports = __webpack_public_path__ + "components/country-flag/static/tk-cac019d29b37deace789f6259590dc91.svg";